import { useState } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { withTranslation } from '~/i18n'
import { Container, LoginForm } from '~/components'
import { getData } from '~/utils/api'
import cookies from 'next-cookies'
import Cookie from 'js-cookie'

const Login = ({ t, i18n, locale = 'en' }) => {
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [needEmail, setNeedEmail] = useState(false)
  const [needNewPass, setNeedNewPass] = useState(false)
  const router = useRouter()

  i18n.serverLanguageDetection = false
  i18n.browserLanguageDetection = false
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale) 
  }

  const onSubmit = async (username, password, email, newPassword, changingPass) => {
    setLoading(true)
    setError('')

    if (username) {
      Cookie.set('username', username.toLowerCase())
    }

    if (changingPass) {
      if (!newPassword || newPassword.length < 8) {
        setLoading(false)
        setError(t("Password needs to be at least 8 characters long"))
        return
      } else if (!(/\d/.test(newPassword))) {
        setLoading(false)
        setError(t("Password should contain at least one digit"))
        return
      } else if (!(/[a-z]/.test(newPassword))) {
        setLoading(false)
        setError(t("Password should contain at least one lowercase character"))
        return
      }
    }

    const { success, needEmail, needNewPass, error, access_token, access_realm } = await getData('/api/v1/auth', { username, password, email, newpassword: newPassword })

    if (success) {
      if (typeof window !== 'undefined') {
        if (window.location.href.includes('backUrl')) {
          window.location.href += `&success=ok&access_token=${access_token}&access_realm=${access_realm}`
        } else {
          router.reload()
        }
      } else {
        router.reload()
      }
    } else if (needEmail || needNewPass) {
      setLoading(false);
      setNeedEmail(needEmail);
      setNeedNewPass(needNewPass);
    } else {
      setLoading(false)
      setError(t('Incorrect username or password'))
    }
  }

  return (
    <>
      <Head>
        <title>{t('Login')} - Via.Delivery</title>
      </Head>
      <Container className="py-8 flex flex-col items-center justify-center ">
        <img
          src="/assets/viadelivery-logo.png"
          alt="Via.Delivery"
          width={160}
          height={54}
        />
        <div className="p-8 rounded bg-white mt-8 shadow-lg text-center">
          <h2 className="text-3xl font-bold text-gray-700">{t('Login')}</h2>
          <div className="mb-8 mt-4">
            {t(needEmail || needNewPass ? 'Auth process changing' : 'Please enter your credentials to login')}
          </div>
          <LoginForm
            onSubmit={onSubmit}
            error={error}
            loading={loading}
            needEmail={needEmail}
            needNewPass={needNewPass}
            t={t}
          />
        </div>
      </Container>
    </>
  )
}

Login.getInitialProps = ctx => {
  const { 'next-i18next': locale } = cookies(ctx)
  return {
    namespacesRequired: ['Login'],
    locale,
  }
}

export default withTranslation('Login')(Login)
